import { render, staticRenderFns } from "./ReservationDetailView.vue?vue&type=template&id=0388780d"
import script from "./ReservationDetailView.vue?vue&type=script&lang=js"
export * from "./ReservationDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports